export function OutlinePlantillaIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_29848_88185)">
        <path
          d="M16.8758 11.4121L10.178 18.104C10.0179 18.27 9.80453 18.3767 9.57337 18.4122L7.20838 18.7856C6.84682 18.839 6.53267 18.5248 6.58601 18.1633L6.95351 15.7924C6.98907 15.5671 7.09576 15.3537 7.26173 15.1878L13.9536 8.49586C14.3804 8.06909 15.0798 8.06909 15.5125 8.49586L16.8758 9.85913C17.3026 10.2859 17.3026 10.9794 16.8758 11.4121Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M7.9314 14.5234L10.8476 17.4397"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeMiterlimit="10"
        />
        <path
          d="M16.354 0.748047V4.65413C16.354 4.95642 16.597 5.19944 16.8993 5.19944H20.7817"
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
        <path
          d="M20.7819 22.0271V5.03355C20.7819 4.71347 20.6574 4.39933 20.4262 4.16816L17.4152 1.10968C17.184 0.872588 16.8699 0.742188 16.5379 0.742188H4.22695C3.54531 0.742188 3 1.29343 3 1.96914V22.0152C3 22.6969 3.55124 23.2422 4.22695 23.2422H19.549C20.2306 23.2422 20.7759 22.6909 20.7759 22.0152L20.7819 22.0271Z"
          stroke={stroke}
          strokeWidth={strokeWidth}
        />
      </g>
    </svg>
  );
}
